// extracted by mini-css-extract-plugin
export default {"characters_list":"Characters_characters_list__Vy0Zy","add_new_icon":"Characters_add_new_icon__EY-fW","back":"Characters_back__4lpPi","content":"Characters_content__xAXzU"};